(function () {
  var rootSelector = '[data-product-quartz-sound], [data-product-clean-sound-faq], [data-product-reviews]';
  var initializedKey = 'productQuartzSoundInitialized';
  var mountedClass = 'lx-product-quartz-background-mounted';
  var activeClass = 'lx-product-quartz-body-gradient-active';
  var gradientModeClass = 'lx-product-quartz-background-mode-gradient';
  var blackModeClass = 'lx-product-quartz-background-mode-black';
  var overlayClass = 'lx-product-quartz-background-overlay';
  var hostClass = 'lx-product-quartz-background-host';
  var roots = [];
  var scrollFrame = null;
  var observer = null;

  function keepOverlayVisible(overlay) {
    if (!overlay.firstChild) {
      overlay.appendChild(document.createTextNode(' '));
    }
  }

  function getCssLength(name) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var parsed = parseFloat(value);

    if (!Number.isFinite(parsed)) {
      return null;
    }

    if (value.indexOf('rem') !== -1) {
      var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;

      return parsed * rootFontSize;
    }

    return parsed;
  }

  function getViewportHeight() {
    return (
      getCssLength('--lx-viewport-height') ||
      (window.visualViewport && window.visualViewport.height) ||
      window.innerHeight ||
      document.documentElement.clientHeight
    );
  }

  function getOverlay() {
    var host = document.body;
    var overlay = document.querySelector('.' + overlayClass);

    if (overlay && overlay.parentNode !== host) {
      host.insertBefore(overlay, host.firstChild);
    }

    if (overlay) {
      keepOverlayVisible(overlay);
      host.classList.add(hostClass);
      return overlay;
    }

    overlay = document.createElement('div');
    overlay.className = overlayClass;
    overlay.setAttribute('aria-hidden', 'true');
    keepOverlayVisible(overlay);
    overlay.style.background = '#000000';
    overlay.style.bottom = 'auto';
    overlay.style.height = 'var(--lx-viewport-height, 100vh)';
    overlay.style.inset = '0 0 auto 0';
    overlay.style.left = '0';
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    overlay.style.position = 'fixed';
    overlay.style.right = '0';
    overlay.style.top = '0';
    overlay.style.transition = 'opacity 0.72s cubic-bezier(0.22, 1, 0.36, 1)';
    overlay.style.width = '100vw';
    overlay.style.zIndex = '1';
    host.insertBefore(overlay, host.firstChild);
    host.classList.add(hostClass);
    document.documentElement.classList.add(hostClass);
    document.body.classList.add(mountedClass);
    document.documentElement.classList.add(mountedClass);

    return overlay;
  }

  function getRootMode(root) {
    if (root && root.matches && root.matches('[data-product-clean-sound-faq], [data-product-reviews]')) {
      return 'black';
    }

    return 'gradient';
  }

  function pruneRoots() {
    roots = roots.filter(function (entry) {
      return entry.root && entry.root.isConnected;
    });
  }

  function getTriggerOffset() {
    var viewportHeight = getViewportHeight();
    var triggerOffset = 0;

    document.querySelectorAll('.shopify-section-group-header-group, .section-header, .header-wrapper').forEach(function (element) {
      var rect = element.getBoundingClientRect();

      if (rect.height <= 0 || rect.bottom <= 0 || rect.top >= viewportHeight) {
        return;
      }

      triggerOffset = Math.max(triggerOffset, Math.min(rect.bottom, viewportHeight));
    });

    return triggerOffset;
  }

  function isRootAtTrigger(root) {
    var rect = root.getBoundingClientRect();
    var triggerOffset = getTriggerOffset();

    return rect.top <= triggerOffset && rect.bottom > triggerOffset;
  }

  function isFooterVisible() {
    var viewportHeight = getViewportHeight();
    var footer = document.querySelector('.shopify-section-group-footer-group');

    if (!footer) {
      return false;
    }

    var rect = footer.getBoundingClientRect();

    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function updateBackgroundState() {
    pruneRoots();
    var overlay = getOverlay();
    var activeMode = null;

    if (isFooterVisible()) {
      activeMode = 'black';
    } else {
      roots.forEach(function (entry) {
        if (isRootAtTrigger(entry.root)) {
          activeMode = entry.mode;
        }
      });
    }

    var shouldActivate = activeMode !== null;
    overlay.style.opacity = shouldActivate ? '1' : '0';
    document.body.classList.toggle(activeClass, shouldActivate);
    document.documentElement.classList.toggle(activeClass, shouldActivate);
    document.body.classList.toggle(gradientModeClass, activeMode === 'gradient');
    document.documentElement.classList.toggle(gradientModeClass, activeMode === 'gradient');
    document.body.classList.toggle(blackModeClass, activeMode === 'black');
    document.documentElement.classList.toggle(blackModeClass, activeMode === 'black');
    scrollFrame = null;
  }

  function scheduleUpdate() {
    if (scrollFrame) {
      return;
    }

    scrollFrame = window.requestAnimationFrame(updateBackgroundState);
  }

  function initRoot(root) {
    if (!root || root.dataset[initializedKey] === 'true') {
      return;
    }

    root.dataset[initializedKey] = 'true';
    roots.push({
      root: root,
      mode: getRootMode(root)
    });
    getOverlay();

    if ('IntersectionObserver' in window && !observer) {
      observer = new IntersectionObserver(scheduleUpdate, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 0.01]
      });
    }

    if (observer) {
      observer.observe(root);
    }

    scheduleUpdate();
  }

  function initAll(scope) {
    var searchScope = scope || document;

    if (searchScope.matches && searchScope.matches(rootSelector)) {
      initRoot(searchScope);
      return;
    }

    searchScope.querySelectorAll(rootSelector).forEach(initRoot);
  }

  function watchForSectionUpdates() {
    if (!('MutationObserver' in window)) {
      return;
    }

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          initAll(node);
        });
      });

      scheduleUpdate();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindEvents() {
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);
    window.addEventListener('lumenearz:viewportchange', scheduleUpdate);
  }

  function boot() {
    initAll(document);
    watchForSectionUpdates();
    bindEvents();
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    scheduleUpdate();
  });

  document.addEventListener('shopify:section:unload', function () {
    pruneRoots();
    scheduleUpdate();
  });
})();
